import { Link } from 'react-router-dom';

const columns = [
  {
    title: '内容栏目',
    links: [
      { to: '/plot', label: '剧情介绍' },
      { to: '/characters', label: '角色设定' },
      { to: '/episodes', label: '分集剧情' },
      { to: '/faq', label: '常见问题' },
    ],
  },
  {
    title: '快速导读',
    links: [
      { to: '/', label: '首页' },
      { to: '/plot', label: '故事主线' },
      { to: '/characters', label: '人物关系' },
      { to: '/episodes', label: '最新更新' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-background-50">
      <div className="mx-auto w-full max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="sm:col-span-2 lg:col-span-2">
            <Link to="/" className="flex items-center gap-2 cursor-pointer">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/15">
                <i className="ri-emotion-happy-line text-lg text-accent-300" />
              </span>
              <span className="font-heading text-xl">泡在我家的辣妹</span>
            </Link>
            <p className="mt-4 max-w-md text-sm leading-7 text-background-100/80">
              专注整理《泡在我家的辣妹》漫画的剧情主线、核心设定与分集看点，帮你快速理清故事走向，看漫画前先补课，追更不迷路。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/10 text-background-50/80 cursor-pointer hover:bg-background-50/20">
                <i className="ri-wifi-line text-lg" />
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/10 text-background-50/80 cursor-pointer hover:bg-background-50/20">
                <i className="ri-mail-line text-lg" />
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/10 text-background-50/80 cursor-pointer hover:bg-background-50/20">
                <i className="ri-chat-3-line text-lg" />
              </span>
            </div>
          </div>

          {columns.map((col) => (
            <div key={col.title}>
              <h3 className="font-heading text-base text-accent-300">{col.title}</h3>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-background-100/80 transition-colors hover:text-accent-200 cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-background-50/15 pt-6 sm:flex-row">
          <p className="text-xs text-background-100/60">
            © {new Date().getFullYear()} 泡在我家的辣妹资料站 · 本站内容仅作剧情整理与介绍
          </p>
          <p className="text-xs text-background-100/60">看漫画前先补课，追更不迷路</p>
        </div>
      </div>
    </footer>
  );
}